// Reporting-page stat tile — simpler variant of dashboard/SummaryCard.tsx (no icon/link, just
// label/value/sub), matching the same glass-card + rounded-xl convention.
interface StatTileProps {
  label: string;
  value: string | number;
  sub?: string;
}

export function StatTile({ label, value, sub }: StatTileProps) {
  return (
    <div className="glass-card rounded-xl p-4">
      <p className="text-xs font-bold uppercase tracking-wider text-slate-400">{label}</p>
      <p className="text-2xl font-bold mt-1 text-slate-800 tabular-nums">{value}</p>
      {sub && <p className="text-xs mt-1 text-slate-400 min-h-[14px]">{sub}</p>}
    </div>
  );
}
